<template>
  <v-ons-page modifier="secondary">
    <v-ons-button
      modifier="light back"
      @click="backToTop"
    >
      戻る
    </v-ons-button>
    <div class="content">
      <div class="food_menu">
        <v-ons-row>
          <v-ons-col class="col">
            <div class="img1">
              <img src="~@/assets/images/menu1.jpg">
            </div>
          </v-ons-col>
          <v-ons-col class="col">
            <div class="img2">
              <img src="~@/assets/images/menu2.jpg">
            </div>
          </v-ons-col>
        </v-ons-row>
        <v-ons-row>
          <v-ons-col class="col">
            <div class="img3">
              <img src="~@/assets/images/menu3.jpg">
            </div>
          </v-ons-col>
          <v-ons-col class="col">
            <div class="img4">
              <img src="~@/assets/images/menu4.jpg">
            </div>
          </v-ons-col>
        </v-ons-row>
      </div>
    </div>
  </v-ons-page>
</template>

<script>

export default {
  methods: {
    backToTop() {
      this.$store.commit('appNavigator/pop');
    },
  },
};
</script>

<style scoped lang="scss">
.food_menu {
  text-align: center;
}
.col {
  height: 445px;

  &:nth-child(2n-1) {
    text-align: right;
  }
  &:nth-child(2n) {
    text-align: left;
  }
  .img1, .img2, .img3, .img4 {
    display: inline-block;
    padding: 5px;
    height: 100%;
    box-sizing: border-box;
  }
  .img1 {
    border-right: 3px solid #7d7d7d;
    border-bottom: 3px solid #7d7d7d;
  }
  .img2 {
    border-left: 3px solid #7d7d7d;
    border-bottom: 3px solid #7d7d7d;
  }
  .img3 {
    border-right: 3px solid #7d7d7d;
    border-top: 3px solid #7d7d7d;
  }
  .img4 {
    border-left: 3px solid #7d7d7d;
    border-top: 3px solid #7d7d7d;
  }
  img {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// food_menu.vue?12691a26